import { useMemo } from 'react';

type PlatformUser = {
    firstTradedTimestamp: number;
    lastInteractionTimestamp: number;
    referrerRegistrationTimestamp: number | null;
};

let cachedUsers: PlatformUser[] | null = null;

const generateMockUsers = (count: number): PlatformUser[] => {
    if (cachedUsers) return cachedUsers;

    const now = Math.floor(Date.now() / 1000);
    const users: PlatformUser[] = [];

    for (let i = 0; i < count; i++) {
        const daysAgo = Math.floor(Math.random() * 60);
        const firstTradedTimestamp =
            now - daysAgo * 86400 - Math.floor(Math.random() * 86400);
        const lastInteractionTimestamp =
            firstTradedTimestamp + Math.floor(Math.random() * 86400 * 30);
        const isReferred = Math.random() > 0.6;

        users.push({
            firstTradedTimestamp,
            lastInteractionTimestamp: Math.min(lastInteractionTimestamp, now),
            referrerRegistrationTimestamp: isReferred
                ? firstTradedTimestamp - Math.floor(Math.random() * 86400)
                : null,
        });
    }

    cachedUsers = users;
    return users;
};

const useMockPlatformUsers = () => {
    const platformUsers = useMemo<PlatformUser[]>(() => {
        return generateMockUsers(150);
    }, []);

    return {
        platformUsers,
        isLoading: false,
        error: undefined,
    };
};

export default useMockPlatformUsers;
